var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSupport = function SvgSupport(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.1C4 10.0363 4.20693 8.983 4.60896 8.00026C5.011 7.01753 5.60028 6.12459 6.34315 5.37243C7.08601 4.62028 7.96793 4.02364 8.93853 3.61658C9.90914 3.20951 10.9494 3 12 3C13.0506 3 14.0909 3.20951 15.0615 3.61658C16.0321 4.02364 16.914 4.62028 17.6569 5.37243C18.3997 6.12459 18.989 7.01753 19.391 8.00026C19.7931 8.983 20 10.0363 20 11.1V15.6V17.4C20 18.3548 19.6254 19.2705 18.9586 19.9456C18.2918 20.6207 17.3874 21 16.4444 21H12",
    stroke: "currentColor",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10H6C7.65685 10 9 11.3431 9 13V15C9 16.6569 7.65685 18 6 18C4.34315 18 3 16.6569 3 15V10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13C15 11.3431 16.3431 10 18 10H21V15C21 16.6569 19.6569 18 18 18C16.3431 18 15 16.6569 15 15V13Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSupport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "support.fcdb5f19df08df0badcc2b52fc50a030.svg";